import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {

    getOrders (page, pageSize, showDrafts,status,customerId,start,end,current,showUnsynchronisedOrders, channel, isPendingValidationOrder) {
        return axios.get('/api/orders/list', { params: { page: page, pageSize: pageSize, showDrafts: showDrafts , status:status,customerId:customerId, start:start,end:end,current:current,showUnsynchronisedOrders:showUnsynchronisedOrders, channel:channel, isPendingValidationOrder:isPendingValidationOrder} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrder (orderId) {
        return axios.get('/api/orders/order', { params: { orderId: orderId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    canceledPartnerOrder (orderId) {
        return axios.get('/api/orders/canceled-partner-order', { params: {orderId: orderId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersByCustomer (page, pageSize,supplierId, onlyDrafts,status,current,start,end, channel, ignorePagination, isPendingValidationOrder) {
        return axios.get('/api/orders/customer/list', { params: { page: page, pageSize: pageSize,supplierId:supplierId, showDrafts: onlyDrafts, status : status,current:current, start:start,end:end, channel:channel , ignorePagination:ignorePagination, isPendingValidationOrder:isPendingValidationOrder} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getDraftOrdersByCurrentUser (page, pageSize) {
        return axios.get('/api/orders/customer/draft/list', { params: { page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    submitPanacheOffer(orderId, itemsToOrder, offeredItems, dbAgencyId) {
        var request = {orderId: orderId, itemsToOrder: itemsToOrder, panacheOfferedItems: offeredItems,offeredItems:offeredItems, dbAgencyId: dbAgencyId}

        return axios.post('/api/orders/panache/submit', request)
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error); return false;})
    
    },

    // entryMode (optional): CATALOG, QUICK_ORDER, IMPORT_CSV or IMPORT_XLS, kept on the order line for statistics
    addLineToOrder (orderId, itemId, quantity, promotionId , isChecked, entryMode, dbAgencyId) {
        var orderLine = {orderId: orderId,
            itemId: itemId,
            quantity: quantity,
            promotionId: promotionId,
            isCashPaymentDiscountChecked:isChecked,
            dbAgencyId:dbAgencyId, 
            entryMode: entryMode }
        
        return axios.post('/api/orders/line/add', orderLine)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch((error) => {
        const status = error?.status;

        if (status === 428) {
            return Promise.reject(error);
        }

        Vue.prototype.$snotify.error(error);
        });
    },

    importQuickOrderCsv(orderId, file, dbAgencyId) {
        const formData = new FormData();
        formData.append('file', file);
        if (orderId) formData.append('orderId', orderId);
        if (dbAgencyId !== null && dbAgencyId !== undefined && dbAgencyId !== '') formData.append('dbAgencyId', dbAgencyId);

        return axios.post('/api/orders/line/import-csv', formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
            if (response && response.data) return response.data;
        });
    },

    editLineToOrder (orderId, itemId, quantity, supplierId, promotionId, isChecked) {
        var orderLine = {orderId: orderId, itemId: itemId, quantity: quantity, supplierId: supplierId, promotionId:promotionId,isCashPaymentDiscountChecked:isChecked}
        
        return axios.post('/api/orders/line/edit', orderLine)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch((error) => {
        const status = error?.status;

        if (status === 428) {
            return Promise.reject(error);
        }

        Vue.prototype.$snotify.error(error);
        });
    },

    validateOrder (orderId) {    
        return axios.get('/api/orders/validate', {params: {orderId:orderId} })
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.orders.submitOrder'));
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error); return false;})
    },

    submitOrder (orderId, message, priority, deliveryAddressCode, isChecked,desiredDeliveryDate,promotionCode, selectedDeliveryMode, ) {    
        var request = {orderId: orderId, message: message, priority: priority, deliveryAddressCode: deliveryAddressCode,isCashPaymentDiscountChecked:isChecked,desiredDeliveryDate:desiredDeliveryDate,promotionCode:promotionCode, selectedDeliveryMode: selectedDeliveryMode}    
        return axios.post('/api/orders/submit', request)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.orders.submitOrder'));
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error); return false;})
    },

    addOrderLineNote(orderLineId, note) {    
        return axios.get('/api/orders/add/orderline/note', {params:{orderLineId: orderLineId, note: note} })
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error); return false;})
    },


    checkOrder (orderId, message, priority, deliveryAddress, isChecked,desiredDeliveryDate,promotionCode) {    
        var request = {orderId: orderId, message: message, priority: priority, deliveryAddress: deliveryAddress,isCashPaymentDiscountChecked:isChecked,desiredDeliveryDate:desiredDeliveryDate,promotionCode:promotionCode}    
        return axios.post('/api/orders/check', request)
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        //.catch(error => {     console.log(error); return false;         /*Vue.prototype.$snotify.error(error); return false;*/})
    },

    blockOrders (isBlock, message) {    
        var request = {isBlock: isBlock, message: message}    
        return axios.post('/api/orders/block-orders', request)
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getBlockOrdersStatus () {    
        return axios.get('/api/orders/block-orders')
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCustomerBlockedStatus () {    
        return axios.get('/api/orders/customer-blocked')
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getIsCustomerInfoMissing() {    
        return axios.get('/api/orders/customer-info-is-missing')
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCustomerDeliveryAddresses (customerId) {
        return axios.get('/api/orders/customer/deliveryAdresses', {params:{customerId:customerId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getDeliveryModes () {
        return axios.get('/api/orders/deliveryModes')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeOrderLine (orderId, itemId, supplierId,isChecked) {
        var orderLine = {orderId: orderId, itemId: itemId, supplierId: supplierId,isCashPaymentDiscountChecked:isChecked}
        return axios.post('/api/orders/remove',orderLine )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch((error) => {
            const status = error?.status;

            if (status === 428) {
                return Promise.reject(error);
            }

            Vue.prototype.$snotify.error(error);
        });
    },

    getOrderLines(orderId) {
        return axios.get('/api/orders/order',{params: {orderId: orderId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeDraft (draft) {
        return axios.post('/api/orders/draft/remove', draft)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    confirmOrder (orderId, deliveryMode,provisionalDeliveryDate) {
        return axios.post('/api/orders/confirmOrder', { orderId: orderId, deliveryMode: deliveryMode,provisionalDeliveryDate:provisionalDeliveryDate  } )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersCount(status){
        return axios.get('/api/orders/count/',{ params: { status:status} })
        .then(response => {
            if (response && response.data)  return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportOrdersListExcel(page, pageSize, showDrafts,status,customerId,start,end,showDetails,showUnsynchronisedOrders , channel){
        return axios({
            url:'/api/orders/export/excel/list',
            params: { page: page, pageSize: pageSize, showDrafts: showDrafts , status:status,customerId:customerId, start:start,end:end,showDetails:showDetails,showUnsynchronisedOrders:showUnsynchronisedOrders,channel:channel},
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const blob = new Blob(
                [response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                const aEle = document.createElement('a');     // Create a label
                const href = window.URL.createObjectURL(blob);       // Create downloaded link
                aEle.href = href;
                aEle.download = response.headers["filename"];  // File name after download
                document.body.appendChild(aEle);
                aEle.click();     // Click to download
                document.body.removeChild(aEle); // Download complete remove element
                window.URL.revokeObjectURL(href) // Release blob object
                
          });
    },

    export(page, pageSize, showDrafts,status,customerId,start,end,showDetails,showUnsynchronisedOrders , channel){
        return axios({
            url:'/api/orders/export/excel/check',
            params: { page: page, pageSize: pageSize, showDrafts: showDrafts , status:status,customerId:customerId, start:start,end:end,showDetails:showDetails,showUnsynchronisedOrders:showUnsynchronisedOrders,channel:channel},
            method: 'GET',
          }).then(() => {
            
            return this.exportOrdersListExcel(page, pageSize, showDrafts,status,customerId,start,end,showDetails,showUnsynchronisedOrders, channel);
                
        }).catch(error => {Vue.prototype.$snotify.error(error);});
    },

    exportEXCEL(orderId){
        axios({
            url:'/api/orders/export/excel/'+orderId,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const blob = new Blob(
                [response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                const aEle = document.createElement('a');     // Create a label
                const href = window.URL.createObjectURL(blob);       // Create downloaded link
                aEle.href = href;
                aEle.download = response.headers["filename"];  // File name after download
                document.body.appendChild(aEle);
                aEle.click();     // Click to download
                document.body.removeChild(aEle); // Download complete remove element
                window.URL.revokeObjectURL(href) // Release blob object
          });
    },

    exportOrder(orderId){
        return axios({
            url:'/api/orders/export/excel/'+orderId,
            method: 'GET',
          }).then(() => {
            
            return this.exportEXCEL(orderId);
                
        }).catch(error => {Vue.prototype.$snotify.error(error);});
    },

    restartSync(orderId){
        return axios.post('/api/orders/restartSync/'+orderId )
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.orders.syncSuccess'));
                return response.data;
            }
            else{
                {Vue.prototype.$snotify.error(i18n.t('services.orders.syncError'));}
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findOrdersByItem(page, pageSize, itemRef) {
        return axios.get('/api/orders/item', { params: { page: page, pageSize: pageSize, itemRef:itemRef} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },



    getTotalSalesPerCustomerAndSupplier(page,pageSize,start,end,customerId,supplierId,isCurrentMonth,isListPerCustomer,isListPerSupplier){
        return axios.get('/api/orders/totalSalesPerCustomerAndSupplier',{params: {page: page, pageSize: pageSize, start:start,end:end,customerId:customerId,supplierId:supplierId,isCurrentMonth:isCurrentMonth,isListPerCustomer:isListPerCustomer,isListPerSupplier:isListPerSupplier} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getFtpImportedOrders(page,pageSize,start,end,customerId){
        return axios.get('/api/orders/ftpImportedOrders',{params: {page: page, pageSize: pageSize, start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    markIsIiewedChangedOrderLine(numBc, codArt){
        return axios.get('/api/orders/mark-is-viewed-orderLine', {params : {numBc:numBc, codArt:codArt}})
        .then(response => {
            if (response && response.data) {
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },
}

